module.exports = __webpack_public_path__ + "lp/img/icon_folder.1a1db299.svg";